import React, { useMemo, useCallback } from 'react';
import Accordion from 'components/Accordion';
import useSoil from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useSoil';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import Button from 'components/DesignSystem/Button';

export default function Soil() {
  const { soilTypes, selectedSoil, setSoil } = useSoil();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('soil-accordion'), []);
  const setSoilAndClose = useCallback((newSoil: number) => {
    setSoil(newSoil);
    closeAccordion();
  }, [setSoil, closeAccordion]);

  return (
    <Accordion.Item eventKey="soil" id="soil-accordion">
      <Accordion.Header>Tipo de Solo</Accordion.Header>
      <Accordion.Body>
        { soilTypes?.map((soil) => (
          <Button
            key={soil.id}
            type="tertiary"
            onClick={() => setSoilAndClose(soil.id)}
            className={`w-100 btn-control-panel ${selectedSoil === soil.id ? 'btn-control-panel-active' : ''}`}
          >
            {soil.label}
          </Button>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
